import { gql } from "@apollo/client";

const MeetingTranscriptFragment = gql`
  fragment MeetingTranscriptFragment on MeetingNode {
    hasTranscript
    notesSummary
    transcript {
      id
      summary
      longSummary
      orderedTranscriptData {
        text
        speaker
        created
        startTimestamp
        messageId
      }
      highlights
      highlightList {
        edges {
          node {
            id
            highlight
          }
        }
      }
      highlightCategories {
        edges {
          node {
            id
            categoryTitle
            highlights {
              edges {
                node {
                  id
                  highlight
                }
              }
            }
          }
        }
      }
      videoRecording
      recallVideoRecording
      canSaveVideoRecording
      videoRecordingAvailableUntil
    }
  }
`;

export default MeetingTranscriptFragment;
